export const ENCODE_REQUEST = 'ENCODE_REQUEST'
export const ENCODE_SUCCESS = 'ENCODE_SUCCESS'
export const ENCODE_FAIL = 'ENCODE_FAIL'
export const ENCODE_RESET = 'ENCODE_RESET'

export const RESET_GENERATED_PCR = 'RESET_GENERATED_PCR'
export const ADD_SAMPLE_PCR = 'ADD_SAMPLE_PCR'

export const GENERATE_SOAP_REQUEST = 'GENERATE_SOAP_REQUEST'
export const GENERATE_SOAP_SUCCESS = 'GENERATE_SOAP_SUCCESS'
export const GENERATE_SOAP_FAIL = 'GENERATE_SOAP_FAIL'

export const GENERATE_REPORT_REQUEST = 'GENERATE_REPORT_REQUEST'
export const GENERATE_REPORT_SUCCESS = 'GENERATE_REPORT_SUCCESS'
export const GENERATE_REPORT_FAIL = 'GENERATE_REPORT_FAIL'

export const APPLY_TEMPLATE_REQUEST = 'APPLY_TEMPLATE_REQUEST'
export const APPLY_TEMPLATE_SUCCESS = 'APPLY_TEMPLATE_SUCCESS'
export const APPLY_TEMPLATE_FAIL = 'APPLY_TEMPLATE_FAIL'
export const RESET_APPLY_TEMPLATE = 'RESET_APPLY_TEMPLATE'

export const CONCISE_REPORT_REQUEST = 'CONCISE_REPORT_REQUEST'
export const CONCISE_REPORT_SUCCESS = 'CONCISE_REPORT_SUCCESS'
export const CONCISE_REPORT_FAIL = 'CONCISE_REPORT_FAIL'
export const RESET_CONCISE_REPORT = 'RESET_CONCISE_REPORT'

export const REPORT_FEEDBACK_REQUEST = 'REPORT_FEEDBACK_REQUEST'
export const REPORT_FEEDBACK_SUCCESS = 'REPORT_FEEDBACK_SUCCESS'
export const REPORT_FEEDBACK_FAIL = 'REPORT_FEEDBACK_FAIL'
export const RESET_REPORT_FEEDBACK = 'RESET_REPORT_FEEDBACK'

export const RECLASSIFY_REQUEST = 'RECLASSIFY_REQUEST'
export const RECLASSIFY_SUCCESS = 'RECLASSIFY_SUCCESS'
export const RECLASSIFY_FAIL = 'RECLASSIFY_FAIL'

export const GENERATE_LAB_REQUEST = 'GENERATE_LAB_REQUEST'
export const GENERATE_LAB_SUCCESS = 'GENERATE_LAB_SUCCESS'
export const GENERATE_LAB_FAIL = 'GENERATE_LAB_FAIL'
